import { useAppDispatch, useAppSelector } from '@/shared/lib/redux';
import { YMaps, Map as YMap, ObjectManager, Placemark } from '@pbe/react-yandex-maps';
import { YMapsApi } from '@pbe/react-yandex-maps/typings/util/typing';
import { useRef, useState } from 'react';
import { openInspectStoreModal, selectStoreGeo } from '../../model';
import { IPartnerStoreGeo } from '@/shared/api/partners';

/* override */
const MapPin = Placemark as any

export const Map = () => {
    const [ymaps, setYmaps] = useState<YMapsApi | null>(null)
    const ymapRef = useRef<ymaps.Map | undefined>(undefined)
    const objectManagerRef = useRef<ymaps.ObjectManager>(null)
    const storeGeo = useAppSelector(selectStoreGeo)
    const dispatch = useAppDispatch()

    const handleClick = (geo: IPartnerStoreGeo) => {
        dispatch(openInspectStoreModal(geo))
    }

    return (
        <div className='rounded-2xl overflow-hidden screen:rounded-3xl w-full h-full'>
            <YMaps>
                <YMap
                    instanceRef={ymapRef}
                    width='100%'
                    onLoad={(ymaps: YMapsApi) => setYmaps(ymaps)}
                    height='68vh'
                    defaultState={{ center: [55.75, 37.57], zoom: 9 }}
                    modules={[
                        "geoObject.addon.editor",
                        "layout.ImageWithContent",
                        "geoObject.addon.hint",
                        "templateLayoutFactory",
                        "layout.storage",
                    ]}
                >
                    <ObjectManager
                        instanceRef={objectManagerRef}
                        options={{
                            clusterize: true,
                            gridSize: 32,
                        }}
                        objects={{
                            preset: "islands#icon",
                            openBalloonOnHover: true
                        }}
                        clusters={{
                            preset: "islands#invertedVioletClusterIcons",
                        }}
                    />
                    {ymaps && storeGeo.map(geo =>
                        <MapPin
                            key={geo.id}
                            modules={[
                                "geoObject.addon.balloon",
                                "geoObject.addon.hint"
                            ]}
                            options={{
                                hintLayout: ymaps.templateLayoutFactory.createClass(`
                                    <div class="w-fit p-2 text-nowrap font-bold text-center bg-white border rounded-xl">
                                        ${geo.name || 'Торговая точка ' + geo.partnerName}
                                    </div>
                                `),
                                hintOpenTimeout: 100,
                                hintCloseTimeout: 1 
                            }}
                            onClick={() => handleClick(geo)}
                            geometry={geo.coordinates || undefined}
                        />
                    )}
                </YMap>
            </YMaps>
        </div>
    )
}